import * as Types from '@/types';

import * as Apollo from '@apollo/client';
import { gql } from '@apollo/client';
import { useLazyQuery } from '@/hooks/use-lazy-query';
import { useWrappedQuery } from '@/hooks/use-wrapped-query';
const defaultOptions = {} as const;

export const GetPricingHubCostChangesDocument = gql`
  query GetPricingHubCostChanges {
    getPricingHubCostChanges {
      item_count
      weekly_gp_impact_in_micros
    }
  }
`;
export function useGetPricingHubCostChangesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.GetPricingHubCostChangesQuery,
    Types.GetPricingHubCostChangesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.GetPricingHubCostChangesQuery,
    Types.GetPricingHubCostChangesQueryVariables
  >(GetPricingHubCostChangesDocument, options);
}
export function useGetPricingHubCostChangesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.GetPricingHubCostChangesQuery,
    Types.GetPricingHubCostChangesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.GetPricingHubCostChangesQuery,
    Types.GetPricingHubCostChangesQueryVariables
  >(GetPricingHubCostChangesDocument, options);
}
export type GetPricingHubCostChangesQueryHookResult = ReturnType<
  typeof useGetPricingHubCostChangesQuery
>;
export type GetPricingHubCostChangesLazyQueryHookResult = ReturnType<
  typeof useGetPricingHubCostChangesLazyQuery
>;
export type GetPricingHubCostChangesQueryResult = Apollo.QueryResult<
  Types.GetPricingHubCostChangesQuery,
  Types.GetPricingHubCostChangesQueryVariables
>;

/**
 * Wrapped version of useGeneratedGetPricingHubCostChangesQuery using Pepper's useWrappedQuery
 */
export function useGeneratedGetPricingHubCostChangesQuery(
  options?: Apollo.QueryHookOptions<
    Types.GetPricingHubCostChangesQuery,
    Types.GetPricingHubCostChangesQueryVariables
  >,
) {
  return useWrappedQuery<
    Types.GetPricingHubCostChangesQuery,
    Types.GetPricingHubCostChangesQueryVariables
  >(GetPricingHubCostChangesDocument, options);
}

/**
 * Wrapped version of useGeneratedGetPricingHubCostChangesLazyQuery using Pepper's useLazyQuery
 */
export function useGeneratedGetPricingHubCostChangesLazyQuery(
  lazyOptions?: Omit<
    Apollo.QueryOptions<Types.GetPricingHubCostChangesQueryVariables>,
    'query'
  >,
) {
  return useLazyQuery<
    Types.GetPricingHubCostChangesQuery,
    Types.GetPricingHubCostChangesQueryVariables
  >(GetPricingHubCostChangesDocument, lazyOptions);
}
